import React, { Component, Fragment } from "react";
import { Grid,Dialog,DialogContent,DialogTitle,IconButton, Slide} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from 'styled-components';
import { withStyles } from "@material-ui/core/styles";

import LoanProceedsModal from './LoanProceedsModal';


const localStyles = theme => ({
  dialogPaper: {
    'min-width':'1200px',
    'font-size': '13px'
  },
  dialogTitle: {
    color: 'blue',
    padding: '0 0 0 20px'
  }
});


const FormWrapper = styled(Grid)`
  height:100%;
  
`
const ResultWrapper = styled(Grid)`  
  &&&& {
    max-width: 100%;
  }
`
const StyledDialog = styled(Dialog)`
&&&{
  min-width: 700px;
}
`
const StyledDialogContent = styled(DialogContent)`
  && {
    color: #666;
    min-height: 450px;
    min-width:700px;
  }
`
const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

export function Transition(props) {
  return <Slide direction = "up" {
    ...props
  }
  />;
}

class ModalForm extends Component {
    state = {}

    render(){
        const {isOpen, handleClose, dealId, classes} = this.props;
        return (

          <StyledDialog 
              modal = {true}
              fullWidth  maxWidth="md"
              open={isOpen} 
              autoDetectWindowHeight={false} 
              autoScrollBodyContent={false}
              classes={{paper: classes.dialogPaper}}
              contentStyle={{width: "700px", maxWidth: "none"}}>

              <DialogTitle id="form-dialog-title">
                Loan Proceeds Calculator
                <StyledDialogIconButton onClick={handleClose}>
                  <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
                </StyledDialogIconButton>
              </DialogTitle>
              <StyledDialogContent>
                <LoanProceedsModal dealId={dealId} pageOrientation="modal" />

              </StyledDialogContent>
              

          </StyledDialog>)
      }
}


export default withStyles(localStyles)(ModalForm);


